import React, { useEffect, useState } from 'react'

import './style.css'
import Dash from './dashboard'
import { VscWorkspaceTrusted } from 'react-icons/vsc'
import { useSelector } from 'react-redux'

export default function Dashboard() {
  const [name, setName] = useState()
  const { user } = useSelector((state) => state.userReducer)
  useEffect(() => {
    if (typeof window !== 'undefined' && !!user) {
      setName(user.name)
    }
  }, [user])
  return (
    <>
      <div className="bg-gray-100 ">
        <div className="container row m-auto">
          {' '}
          <div className="my-3 text-3xl opacity-30 text-center font-bold">
            <h2>Bienvenue Admin {name}.</h2>
          </div>
          <div className="flex mx-auto justify-center align-items-center gap-1">
            <VscWorkspaceTrusted color="red" size={20} />
            <p className="text-sm text-center text-black">
              Nous vous prions d'etre sage avec les donnees des gens
            </p>
          </div>
          <Dash />
        </div>
      </div>
    </>
  )
}
